import { useGetV8DatabaseInstancesEnabled } from '@/api-client/database/queries/database-instance-v8-controller/database-instance-v8-controller';

/**
 * maxgauge instance count 조회
 * Oracle, MySQL, PostgreSQL, SQL Server GNB에서 사용
 * router guard에서 prefetchInstanceCount()로 prefetch됨
 */
export const useInstanceCount = () => {
  const { data: instanceCount } = useGetV8DatabaseInstancesEnabled(
    {},
    {
      query: {
        select: (response) => response.data.data?.at(0) ?? null,
      },
    },
  );

  return {
    instanceCount,
  };
};
